let globalStyles = require('./globalstyles.global.scss');

export { globalStyles };